// 警報レベルに応じた色を返す
export const getMessageColor = (
  alertLevel: number | undefined
): { color: string; bgColor: string; iconColor: string } => {
  switch (alertLevel) {
    case 1:
      return {
        color: 'white',
        bgColor: '#92D050',
        iconColor: 'white'
      };
    case 2:
      return {
        color: 'black',
        bgColor: '#FFFF00',
        iconColor: '#575757'
      };
    case 3:
      return {
        color: 'white',
        bgColor: '#FFC000',
        iconColor: 'white'
      };
    case 4:
      return {
        color: 'white',
        bgColor: '#FF0000',
        iconColor: 'white'
      };

    default:
      return {
        color: '',
        bgColor: '',
        iconColor: ''
      };
  }
};
